import { useEffect } from 'react';
import { useFeatureServices } from '~/app/contexts/app-context';
import { appTrackingService } from '~/app/tracking/app-tracking-service';
import { useConfiguredVehicle } from '~/app/tracking/use-configured-vehicle';

export function useInitTrackingService() {
	const { trackingService, loggerService } = useFeatureServices();

	useEffect(() => {
		if (process.env.IS_VITE_DEV) {
			appTrackingService.initialize();
		} else {
			appTrackingService.initialize(trackingService, loggerService);
		}
	}, [loggerService, trackingService]);

	useConfiguredVehicle();
}

export function useTrackingService() {
	return appTrackingService;
}
